import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';
import { WHEEL_LIST } from 'src/constants/queryKeys';

export const networkGetWheelInfo = async (wheelId) => {
  const res = await axiosInstance.post(`Wheel/Info/${wheelId}`);
  return res;
};

export const networkGetWheelList = async (payload, pageIndex, pageSize) => {
  const res = await axiosInstance.post(`Wheel/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchWheelList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [WHEEL_LIST, payload, pageIndex],
    queryFn: () => {
      return networkGetWheelList(payload, pageIndex, pageSize);
    },
  });
}

export const networkGetWheelTypeList = async (pageIndex, pageSize) => {
  const res = await axiosInstance.post(`WheelType/List/${pageIndex}/${pageSize}`);
  return res;
};

export function useFetchWheelTypeList(pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: ['wheel-type-list'],
    queryFn: () => {
      return networkGetWheelTypeList(pageIndex, pageSize);
    },
  });
}

export const networkCreateWheel = async (data) => {
  const res = await axiosInstance.post('Wheel/Insert', data);
  return res;
};

export const networkUpdateWheel = async (wheelId, data) => {
  const res = await axiosInstance.post(`Wheel/Update/${wheelId}`, data);
  return res;
};

export const networkRemoveWheel = async (wheelId) => {
  const res = await axiosInstance.post(`Wheel/Remove/${wheelId}`);
  return res;
};
